import React from 'react'
import styled from '@emotion/styled'
import {
  fontSize,
  fontWeight,
  lineHeight,
  device,
  color,
  SmallText,
} from '@ticketswap/solar'

const Price = styled.strong`
  display: block;
  text-align: right;
  color: ${color.space};
  font-size: ${fontSize[18]};
  font-weight: ${fontWeight.semiBold};
  line-height: ${lineHeight.title};

  @media ${device.mobileL} {
    line-height: ${lineHeight.solid};
    font-size: ${fontSize[20]};
  }
`

const StyledSmallText = styled(SmallText)`
  display: block;
  color: ${color.spaceMedium};
`

function PricePerticket({ t, ...props }) {
  return (
    <Price>
      {props.price}
      <StyledSmallText>/ {t('common:generic.ticket')}</StyledSmallText>
    </Price>
  )
}

export default PricePerticket
